/**
 * accordion-faq.js — Phase 5A.3 generic page-level FAQ accordion.
 *
 * Thin wrapper around assets/accordion.js. Imports bindAccordion and
 * calls it for any .accordion-faq section on page load + section reload.
 *
 * See D-N (next available, added later in Phase 5A.3) for shared module rationale.
 */

import { bindAccordion } from './accordion.js';

const SECTION_SELECTOR = '.accordion-faq';

document.querySelectorAll(SECTION_SELECTOR).forEach(bindAccordion);
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll(SECTION_SELECTOR).forEach(bindAccordion);
});
